




















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import {
  ResultadoStatus,
  EstatisticaLeadService,
} from "@/services/estatistica-lead.service";
import moment from "moment";
import dayjs from "dayjs";

@Component({
})
export default class EstatisticasFunilCard extends Vue {
  dados: ResultadoStatus[] | null = null;
  loading = false;

  @Prop() date!: string | null;
  mesAtual: string | null = null;

  mounted() {
    this.fetch();
  }

  @Watch("date")
  fetch() {
    if (!this.date) {
      this.mesAtual = dayjs().format("YYYY-MM");
    } else {
      this.mesAtual = dayjs(this.date).format("YYYY-MM");
    }
    dayjs.locale("pt-br");

    this.carregarResultadoPorStatus();
  }

  async carregarResultadoPorStatus() {
    this.loading = true;

    try {
      this.dados = await EstatisticaLeadService.resultadoPorStatus(
        moment(`${this.mesAtual}-01`).toDate()
      );
    } finally {
      this.loading = false;
    }
  }
}
